// @ts-nocheck
// Stable id for a new custom registration field: snake_case of the name,
// de-duped against the ids already in use (registrant data is keyed by
// fieldId, so ids must be unique within a form and never regenerate on rename).
import _ from 'lodash';

export default function generateFieldId(name, existingIds = []) {
  const base = _.snakeCase(name) || 'field';
  const taken = new Set(existingIds);
  if (!taken.has(base)) return base;
  let n = 2;
  while (taken.has(`${base}_${n}`)) n += 1;
  return `${base}_${n}`;
}
